import type { TabConfig } from 'client/js/main/components/nav/neoTabsConfig';
import type { FlipperFlagValues } from '../../../../../../shared/ProductFlipperFlag.service';

export const ROI_HUB_PAGE_TITLE = 'ROI Hub';

const ROI_HUB_NAV_TABS: TabConfig[] = [
  {
    id: 'mui-tab-roi-overview',
    route: 'overview',
    label: 'Overview',
  },
  {
    id: 'mui-tab-roi-analytics',
    route: 'analytics',
    label: 'Roi Analytics',
  },
  {
    id: 'mui-tab-connection-overview',
    route: 'connection-overview',
    label: 'Connection Overview',
  },
  {
    id: 'mui-tab-file-ingestion',
    route: 'file-ingestion',
    label: 'File Ingestion',
  },
];

export const getRoiHubTabsConfig = (flipperFlags: FlipperFlagValues): TabConfig[] => {
  return flipperFlags.roi_hub_overview
    ? ROI_HUB_NAV_TABS.filter((tab) => tab.route !== 'analytics')
    : ROI_HUB_NAV_TABS.filter((tab) => tab.route !== 'overview');
};
